// @ts-nocheck
// import React, { useCallback, useEffect, useRef, useState } from 'react';
namespace React { export type FC = {} };
// declare var useEffect, useState;
const useCallback = React.useCallback;
const useEffect = React.useEffect;
const useRef = React.useRef;
const useState = React.useState;

interface QueryBuilderWrapperProps
{
    adapter: ReactQueryBuilderAdapter;
}

const ReactQueryBuilderWrapper: React.FC<QueryBuilderWrapperProps> = ({
    adapter,
}) =>
{
    const simpleMode = false;

    const placeholder = 'Hledat …';

    const fields: Field[] = [
        { name: 'latin-orig', label: 'latina: transliterace', placeholder },
        { name: 'czech-reg', label: 'čeština: transkripce', placeholder },
        { name: 'czech-orig', label: 'čeština: transliterace', placeholder },
        { name: 'german', label: 'němčina', placeholder },
        { name: 'greek', label: 'řečtina', placeholder },
        { name: 'text', label: 'vše', placeholder },
    ];

    const initialQuery: RuleGroupType = {
        combinator: simpleMode ? undefined : 'and',
        rules: [
            {
                // just like the Vusín dictionary
                field: 'text', // = all
                operator: 'contains',
                value: '', // měst
            },
        ],
    };

    const [query, setQuery] = useState(initialQuery);

    const controlElements = {}; // QueryBuilderContextProps

    const queryBuilder = <QueryBuilderBootstrap>
        <QueryBuilder
            fields={fields}
            query={query}
            onQueryChange={setQuery}
            addRuleToNewGroups
            resetOnFieldChange={false}
            controlElements={controlElements}
        />
    </QueryBuilderBootstrap>;

    return queryBuilder;
};

//  XXX: default exports are not supported by the loadUMD2GlobalHack
export { ReactQueryBuilderWrapper };
